import gql from 'graphql-tag'

export default gql`
  mutation addEnterpriseMember($email: String!, $payerUserId: String!) {
    addEnterpriseMember(email: $email, payerUserId: $payerUserId) {
      success
      message
    }
  }
`
